module.exports = __webpack_public_path__ + "static/media/rsz_metis.33ed2aed.webp";